import { c as _c } from "react/compiler-runtime";
import { useViewPort } from "@website/hooks/viewport";
import type { MarketingBannerItemDataType } from "@website/widget/banner-slide";
import { BannerSlide } from "@website/widget/banner-slide";
import type { ListingContainerBannerType } from "./listing-container.types";
const BANNER_POSITIONS = {
  slide: 0,
  inline: 4
};
const INLINE_BANNER_HEIGHT = 72;
const slideBannerSizes = {
  desktop: {
    height: 70,
    width: 812
  },
  mobile: {
    height: 87,
    width: 378
  },
  tablet: {
    height: 175,
    width: 760
  }
};
type ListingBannerVariant = "inline" | "slide";
type ListingBannerSize = {
  height: number;
  width?: number;
};
type ListingBannerProperties = {
  className: string;
  isLoading?: boolean;
  list: Array<MarketingBannerItemDataType>;
  variant: ListingBannerVariant;
};
type ListingBannersProperties = {
  banners?: ListingContainerBannerType;
  index: number;
};
function getSlideBannerSize({
  isMobile,
  isTablet
}: {
  isMobile: boolean;
  isTablet: boolean;
}): ListingBannerSize {
  if (isMobile) {
    return slideBannerSizes.mobile;
  }
  if (isTablet) {
    return slideBannerSizes.tablet;
  }
  return slideBannerSizes.desktop;
}
function ListingBanner(t0) {
  const $ = _c(12);
  const {
    className,
    isLoading,
    list,
    variant
  } = t0;
  const {
    isMobile,
    isTablet
  } = useViewPort();
  let t1;
  if ($[0] !== isMobile || $[1] !== isTablet || $[2] !== variant) {
    t1 = variant === "inline" ? {
      height: INLINE_BANNER_HEIGHT
    } : getSlideBannerSize({
      isMobile,
      isTablet
    });
    $[0] = isMobile;
    $[1] = isTablet;
    $[2] = variant;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const bannerSize = t1;
  if (list.length === 0) {
    return null;
  }
  let t2;
  if ($[4] !== bannerSize.height || $[5] !== bannerSize.width || $[6] !== isLoading || $[7] !== list) {
    t2 = <BannerSlide className="w-full !p-0" height={bannerSize.height} isLoading={isLoading} list={list} shouldRedirectUsingJs={true} width={bannerSize.width} />;
    $[4] = bannerSize.height;
    $[5] = bannerSize.width;
    $[6] = isLoading;
    $[7] = list;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[9] !== className || $[10] !== t2) {
    t3 = <div className={className}>{t2}</div>;
    $[9] = className;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
}
export function ListingBanners(t0) {
  const $ = _c(19);
  const {
    banners,
    index
  } = t0;
  let t1;
  if ($[0] !== banners?.slide) {
    t1 = banners?.slide ?? [];
    $[0] = banners?.slide;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const slideBanners = t1;
  let t2;
  if ($[2] !== banners?.inline) {
    t2 = banners?.inline ?? [];
    $[2] = banners?.inline;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const inlineBanners = t2;
  const hasSlideBanners = slideBanners.length > 0;
  const hasInlineBanners = inlineBanners.length > 0;
  const slideBannerPosition = banners?.slidePosition ?? BANNER_POSITIONS.slide;
  const inlineBannerPosition = banners?.inlinePosition ?? BANNER_POSITIONS.inline;
  let t3;
  if ($[4] !== banners?.isLoading || $[5] !== hasSlideBanners || $[6] !== index || $[7] !== slideBannerPosition || $[8] !== slideBanners) {
    t3 = hasSlideBanners && index === slideBannerPosition && <ListingBanner className="col-span-full w-full" isLoading={banners?.isLoading} list={slideBanners} variant="slide" />;
    $[4] = banners?.isLoading;
    $[5] = hasSlideBanners;
    $[6] = index;
    $[7] = slideBannerPosition;
    $[8] = slideBanners;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== banners?.isLoading || $[11] !== hasInlineBanners || $[12] !== index || $[13] !== inlineBannerPosition || $[14] !== inlineBanners) {
    t4 = hasInlineBanners && index === inlineBannerPosition && <ListingBanner className="order-4 w-full" isLoading={banners?.isLoading} list={inlineBanners} variant="inline" />;
    $[10] = banners?.isLoading;
    $[11] = hasInlineBanners;
    $[12] = index;
    $[13] = inlineBannerPosition;
    $[14] = inlineBanners;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  let t5;
  if ($[16] !== t3 || $[17] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[16] = t3;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  return t5;
}